import { useQuery } from '@tanstack/react-query';

import { useRequest } from '@frontend/api';
import type { QueryFunction } from '@frontend/api';

import type { SavedViewDetailsParams, SavedView } from './types';
import {
  getSavedViewDetailsQueryKey,
  type GetSavedViewDetailsQueryKeyType,
} from './utils';

export const useGetSavedViewDetails: QueryFunction<
  SavedView,
  [SavedViewDetailsParams],
  GetSavedViewDetailsQueryKeyType
> = (params, { requestOptions, queryOptions } = {}) => {
  const request = useRequest(requestOptions);
  const queryKey = getSavedViewDetailsQueryKey(params);

  return useQuery({
    ...queryOptions,
    queryKey,
    queryFn: ({ signal }) => {
      return request<SavedView>(`/display_configs/views/${params.viewId}`, {
        init: {
          method: 'GET',
          signal,
        },
      });
    },
  });
};
